import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

const getMargin = (theme, inModal) => {
  if (inModal && theme.modal_img_margin) {
    return `${pxToRem(theme.modal_img_margin)} 0`
  } else if (theme.image_margin) {
    return `${pxToRem(theme.image_margin)}`
  }
  return `${pxToRem(20)} 0`
}

interface PictureContainerProps {
  theme: any;
  $inModal: string;
  $disable: boolean;
  fullSizeGif?: boolean;
}
export const PictureContainer = styled.div<PictureContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: ${({ theme, $inModal }) => getMargin(theme, $inModal)};
  max-width: 100%;

  & > div > div {
    display: block;
    ${({ $disable }) => $disable && `transform: none !important`};
  }

  img {
    max-width: 100%;
  }
`

export const PictureIcons = styled.div`
  position: absolute;
  right: 0;
  height: 100%;
  width: 100%;
  padding-top: 2%;
  padding-right: 2%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  pointer-events: none;

  img {
    width: ${pxToRem(45)};
    border-radius: 100%;
    opacity: ${({ theme }) => (theme.image_icon_background_color ? '1' : '0.7')};
    background: ${({ theme }) =>
      theme.image_icon_background_color ? theme.image_icon_background_color : '#a2a2a2'};
    pointer-events: all;
    border: 1px solid
      ${({ theme }) => (theme.image_icon_border_color ? theme.image_icon_border_color : '#a2a2a2')};
    padding: 2px;

    &:first-of-type {
      margin-bottom: 20%;
    }

    //below line must stay in this location of the code to work!
    ${({ theme }) => theme.image_icon_hidden && 'display: none;'}
  }
`

export const StyledImage = styled.img<PictureContainerProps>`
  width: ${({ fullSizeGif }) => (fullSizeGif || fullSizeGif === undefined? '100%' :'auto')};
`

export const GiphyAttribute = styled.img`
  width: 150px;
`
